// extracted by mini-css-extract-plugin
export default {"card":"remove-homework_card__npNjE","title":"remove-homework_title__eHzU-","text":"remove-homework_text__y0s6M","btns":"remove-homework_btns__xIe5W"};